import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import ConfirmationPopup from "../../components/common/ConfirmationPopup/ConfirmationPopup";
import RouterConstants from "../../constants/RouterConstants";
import useSecureNavigate from "../../hooks/useSecureNavigate";
import { useAppStore } from "../../hooks/useStores";
import TabsLayout, { ITabLayout } from "../../layout/TabsLayout/TabsLayout";
import styles from "./NewTailoredGeneration.module.scss";

const NewTailoredGeneration = () => {
	const navigate = useSecureNavigate();
	const { t } = useTranslation("translation");
	const [shouldShowTrainingPopup, setShouldShowTrainingPopup] = useState(false);

	const { tgStore, uiStore } = useAppStore();
	const { tgModelStore } = tgStore;

	useEffect(() => {
		if (tgModelStore.modelsList.length === 0) {
			tgModelStore
				.listAllModels()
				.then(() => {
					if (tgModelStore.modelsList.length === 0) {
						setShouldShowTrainingPopup(true);
					}
				})
				.catch((err) => {
					console.error("Failed to fetch training models", err);
				});
		}
	}, []);

	const handleStartTraining = () => {
		navigate(RouterConstants.NEW_TG.PROJECTS.fullPath);
		uiStore.setProperty("isTrainingPopupOpen", false);
	};

	const handleDemoTabClick = (e: React.MouseEvent) => {
		if (shouldShowTrainingPopup) {
			e.preventDefault();
			uiStore.setProperty("isTrainingPopupOpen", true);
		}
	};

	const subTabs: ITabLayout[] = [
		{ name: t("overview.tab"), link: RouterConstants.NEW_TG.OVERVIEW.path },
		{ name: t("projects.tab"), link: RouterConstants.NEW_TG.PROJECTS.path },
		{ name: t("accessMethods.tab"), link: RouterConstants.NEW_TG.ACCESS_METHODS.path },
		{ name: t("demo.tab"), link: RouterConstants.NEW_TG.DEMO.path, onClick: handleDemoTabClick },
	];

	return (
		<>
			<TabsLayout contentClassName={styles.content} title={t("header")} subTabs={subTabs}>
				<Outlet />
			</TabsLayout>

			<ConfirmationPopup
				open={uiStore.isTrainingPopupOpen}
				onClose={() => uiStore.setProperty("isTrainingPopupOpen", false)}
				title={t("trainingPopup.title")}
				description={t("trainingPopup.description")}
				confirmButtonText={t("trainingPopup.startTraining")}
				onClick={handleStartTraining}
				hideCancel
			/>
		</>
	);
};

export default observer(NewTailoredGeneration);
